module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/aoj_a-5-b1d9a85981869fc791d99384b8a7957c.jpg";